export const CHANGE_LAYOUT_FORM = "loginUserReducer/CHANGE_LAYOUT_FORM";

export const USER_GUEST_SUCCESS = "loginUserReducer/USER_GUEST_SUCCESS";
export const USER_GUEST_FAILED = "loginUserReducer/USER_GUEST_FAILED";
export const USER_GUEST_REQUEST = "loginUserReducer/USER_GUEST_REQUEST";
